export default {
  bgMusic: '背景音乐',
  bgImage: '背景图片',
  bgColor: '背景颜色',
  defaultLanguage: '默认语言',
  colorChoose: '当背景颜色和背景图片同时存在时，优先展示背景颜色',
  languageChoose:
    '广告投放过程中，若素材包包含的语言未能与设备语言匹配，将会使用此默认语言',
  bgmTipsContent: '支持MP3格式，大小不超过2M',
  bgImgTipsContent: '支持PNG/JPG格式',
  tip: '提示',
  orNotDeleteBgImg: '是否删除背景图片',
  cancelBtn: '取消',
  confirmBtn: '确定',
  gameLoadMessage: '游戏还没加载',
  bgColorMessage: '已设置背景色不能替换背景图,请先删除背景色',
  cancelDelete: '已取消删除',
  deleteSuccess: '删除成功!',
  uploadSuccess: '上传完成!',
  addBgmWarning: '尚未添加背景音效，请先添加',
  orNotDeleteBgm: '是否删除背景音效',
  backgroundAudio: {
    replaceBtn: '替换',
    cutterBtn: '剪辑',
    volume: '音量',
    bgmInfoDuration: '获取中...',
    fileSizeMessage: '背景音乐不能超过2M',
    fileExtMessage: '只能上传mp3格式的音频',
  },
  backgroundImage: {
    uploadBtn: '替换',
    cropBtn: '剪辑',
    filter: '滤镜',
    cropSuccess: '裁剪完成!',
    filterSuccess: '滤镜修改完成',
  },
  backgroundColor: {
    single: '单色',
    gradient: '渐变色',
    toggleMessage: '游戏未加载完毕',
  },
  language: {
    editBtn: '修改语言',
    deleteBtn: '删除语言',
    addBtn: '添加语言',
    deleteConfirm: '确认删除？',
    dialog: {
      addLanguage: '添加语言',
      selectLanguage: '选择语言',
      closeBtn: '取消',
      submitBtn: '提交',
      contentNotEmpty: '请选择地区/语言',
    },
  },
  tabBarList: {
    design: '外观',
    animation: '动画',
    scene: '场景设置',
    global: '全局设置',
    event: '事件',
    gameConfig: '玩法参数',
  },
}
